import { RouteConfig } from "vue-router"

export const companyRoutes: RouteConfig[] = [
    {
        path: "companies",
        component: () => import("@/layouts/Wrapper.vue"),
        meta: { title: "Companies", doNotShow: true },
        children: [
            {
                path: ":companyId",
                component: () => import("@/views/location/Company.vue"),
                meta: { type: "company" },
                children: [
                    {
                        path: "integrated-devices",
                        component: () => import("@/layouts/Wrapper.vue"),
                        children: [
                            {
                                path: "",
                                name: "integrated-devices",
                                component: () => import("@/views/IntegratedDevices.vue"),
                                meta: { title: "Integrated devices" },
                            },
                        ],
                    },
                    {
                        path: "location-groups",
                        component: () => import("@/layouts/Wrapper.vue"),
                        meta: { title: "Location Groups", doNotShow: true },
                        children: [
                            {
                                path: ":locationGroupId",
                                component: () =>
                                    import("@/views/location-groups/LocationGroup.vue"),
                                meta: { type: "location-group" },
                                redirect:
                                    "/companies/:companyId/location-groups/:locationGroupId/flexibility",
                                children: [
                                    {
                                        path: "",
                                        component: () =>
                                            import(
                                                "@/views/location-groups/LocationGroupHeaderView.vue"
                                            ),
                                        meta: { title: "" },
                                        children: [
                                            {
                                                path: "",
                                                redirect: "flexibility",
                                                name: "LocationGroupFlexibility",
                                            },
                                            {
                                                path: "flexibility",
                                                name: "CompanyLocationFlexibilityView",
                                                component: () =>
                                                    import(
                                                        "@/views/location-groups/LocationGroupFlexibilityView.vue"
                                                    ),
                                                meta: {
                                                    title: "Flexibility",
                                                    type: "location-group-flexibility",
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        path: "locations/:locationId",
                                        component: () => import("@/views/location/Location.vue"),
                                        meta: { title: "Location", type: "location" },
                                        children: [
                                            {
                                                path: "",
                                                name: "CompanyLocationAnimation",
                                                component: () =>
                                                    import(
                                                        "@/views/location/LocationOverview.vue"
                                                    ),
                                                meta: { type: "location" },
                                            },
                                            {
                                                path: "reports",
                                                component: () => import("@/layouts/Wrapper.vue"),
                                                meta: { title: "Reports" },
                                                children: [
                                                    {
                                                        path: "",
                                                        name: "CompanyLocationReports",
                                                        component: () =>
                                                            import("@/views/Report.vue"),
                                                        meta: { title: "Reports" },
                                                    },
                                                ],
                                            },
                                            {
                                                path: "manage",
                                                component: () => import("@/layouts/Wrapper.vue"),
                                                meta: { title: "Manage Location" },
                                                children: [
                                                    {
                                                        path: "",
                                                        name: "CompanyManageLocation",
                                                        component: () =>
                                                            import(
                                                                "@/views/settings/ManageLocation.vue"
                                                            ),
                                                        meta: {
                                                            title: "Manage Location",
                                                            type: "manage-location",
                                                        },
                                                    },
                                                    {
                                                        path: "settings",
                                                        name: "CompanyLocationSettings",
                                                        component: () =>
                                                            import(
                                                                "@/views/location/LocationSettings.vue"
                                                            ),
                                                        meta: {
                                                            title: "Location settings",
                                                            type: "location-settings",
                                                        },
                                                    },
                                                    {
                                                        path: "users",
                                                        name: "CompanyLocationUsers",
                                                        component: () =>
                                                            import("@/views/settings/Users.vue"),
                                                        meta: {
                                                            title: "Users",
                                                            type: "location-users",
                                                        },
                                                    },
                                                    {
                                                        path: "structure",
                                                        name: "CompanyLocationStructure",
                                                        component: () =>
                                                            import(
                                                                "@/views/settings/LocationEdit.vue"
                                                            ),
                                                        meta: {
                                                            title: "Structure",
                                                            type: "location-structure",
                                                        },
                                                    },
                                                    {
                                                        path: "oem-devices",
                                                        component: () =>
                                                            import("@/layouts/Wrapper.vue"),
                                                        meta: {
                                                            title: "Devices",
                                                            useDynamicTitle: true,
                                                        },
                                                        children: [
                                                            {
                                                                path: "",
                                                                name: "CompanyLocationOEMDevices",
                                                                component: () =>
                                                                    import(
                                                                        "@/views/settings/OEMDevices.vue"
                                                                    ),
                                                                meta: {
                                                                    title: "Devices",
                                                                    type: "location-controllers",
                                                                },
                                                            },
                                                            {
                                                                path: ":oemDeviceId",
                                                                name: "CompanyLocationOEMDevice",
                                                                component: () =>
                                                                    import(
                                                                        "@/views/settings/oem-device/OEMDevice.vue"
                                                                    ),
                                                                meta: {
                                                                    title: "Device",
                                                                    useTitle: true,
                                                                },
                                                            },
                                                            {
                                                                path: ":oemDeviceId/devices/:deviceId",
                                                                name: "CompanyOEMDevicesDevice",
                                                                component: () =>
                                                                    import(
                                                                        "@/views/settings/Device.vue"
                                                                    ),
                                                                meta: { title: "Device Settings" },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        path: "pricing",
                                                        component: () =>
                                                            import("@/layouts/Wrapper.vue"),
                                                        meta: { title: "Utility Rate Plan" },
                                                        children: [
                                                            {
                                                                path: "",
                                                                name: "CompanyLocationGroupPricing",
                                                                component: () =>
                                                                    import(
                                                                        "@/views/UtilityRatePlan.vue"
                                                                    ),
                                                                meta: {
                                                                    title: "Utility Rate Plan",
                                                                    type: "location-utility-plan",
                                                                },
                                                            },
                                                            {
                                                                path: "price-lists",
                                                                component: () =>
                                                                    import("@/layouts/Wrapper.vue"),
                                                                meta: {
                                                                    title: "utility_rate_plan.pricing_plan",
                                                                },
                                                                children: [
                                                                    {
                                                                        path: "",
                                                                        name: "CompanyLocationGroupPricingEnergy",
                                                                        component: () =>
                                                                            import(
                                                                                "@/views/pricing/EnergyPricing.vue"
                                                                            ),
                                                                        meta: {
                                                                            title: "utility_rate_plan.pricing_plan",
                                                                        },
                                                                    },
                                                                    {
                                                                        path: "create",
                                                                        name: "CompanyLocationGroupCreatePriceList",
                                                                        component: () =>
                                                                            import(
                                                                                "@/views/pricing/PriceListView.vue"
                                                                            ),
                                                                        meta: {
                                                                            title: "Create pricing plan",
                                                                        },
                                                                    },
                                                                    {
                                                                        path: ":priceListId",
                                                                        name: "CompanyLocationGroupEditPriceList",
                                                                        component: () =>
                                                                            import(
                                                                                "@/views/pricing/PriceListView.vue"
                                                                            ),
                                                                        meta: {
                                                                            title: "Edit pricing plan",
                                                                            useTitle: true,
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                            {
                                                                path: "plans",
                                                                component: () =>
                                                                    import("@/layouts/Wrapper.vue"),
                                                                meta: { title: "Time of Use Plan" },
                                                                children: [
                                                                    {
                                                                        path: "",
                                                                        name: "CompanyLocationGroupPricingPlans",
                                                                        component: () =>
                                                                            import(
                                                                                "@/views/pricing/UtilityAndNetworkPlans.vue"
                                                                            ),
                                                                        meta: {
                                                                            title: "Time of Use Plan",
                                                                        },
                                                                    },
                                                                    {
                                                                        path: "create",
                                                                        name: "CompanyLocationGroupCreatePricingPlan",
                                                                        component: () =>
                                                                            import(
                                                                                "@/views/pricing/PricingPlanView.vue"
                                                                            ),
                                                                        meta: {
                                                                            title: "Create utility plan",
                                                                        },
                                                                    },
                                                                    {
                                                                        path: ":planId",
                                                                        name: "CompanyLocationGroupEditPricingPlan",
                                                                        component: () =>
                                                                            import(
                                                                                "@/views/pricing/PricingPlanView.vue"
                                                                            ),
                                                                        meta: {
                                                                            title: "Edit time of use plan",
                                                                            useTitle: true,
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        path: "pricing-plans",
                                                        name: "PricingPlans",
                                                        component: () =>
                                                            import(
                                                                "@/views/pricing-plans/PricingPlans.vue"
                                                            ),
                                                        meta: {
                                                            title: "Pricing plans",
                                                            maintainsContext: false,
                                                        },
                                                    },
                                                    {
                                                        path: "spot-market",
                                                        name: "CompanyLocationGroupSpotMarket",
                                                        component: () =>
                                                            import(
                                                                "@/views/pricing/SpotMarketView.vue"
                                                            ),
                                                        meta: {
                                                            title: "Energy Market Prices",
                                                            type: "location-spot-market",
                                                        },
                                                    },
                                                ],
                                            },
                                            {
                                                path: "charts",
                                                name: "CompanyLocationCharts",
                                                component: () =>
                                                    import("@/views/location/LocationChart.vue"),
                                                meta: {
                                                    title: "Charts",
                                                    type: "location-charts",
                                                },
                                            },
                                            {
                                                path: "category/:categoryId",
                                                name: "CompanyLocationCategory",
                                                component: () =>
                                                    import("@/views/location/LocationCategory.vue"),
                                                meta: { title: "Category info", useTitle: true },
                                            },
                                            {
                                                path: "strategies",
                                                name: "CompanyLocationStrategies",
                                                component: () =>
                                                    import(
                                                        "@/views/location/LocationStrategies.vue"
                                                    ),
                                                meta: {
                                                    title: "Strategies",
                                                    type: "location-strategies",
                                                },
                                            },
                                            {
                                                path: "strategies/:strategyId",
                                                name: "CompanyLocationStrategy",
                                                component: () =>
                                                    import(
                                                        "@/views/settings/oem-device/Strategy.vue"
                                                    ),
                                                meta: { title: "Strategy", useTitle: true },
                                            },
                                            {
                                                path: "ev-charging",
                                                name: "CompanyLocationEvChargingSessions",
                                                component: () =>
                                                    import(
                                                        "@/views/location/ev-charging/EvChargingSessions.vue"
                                                    ),
                                                meta: { title: "EV Charging Sessions", type: "ev-charging" },
                                            },
                                            {
                                                path: "alarm-settings",
                                                name: "CompanyLocationAlarmSettings",
                                                component: () =>
                                                    import(
                                                        "@/views/location/LocationAlarmSettings.vue"
                                                    ),
                                                meta: {
                                                    title: "Alarm settings",
                                                    type: "location-alarm-settings",
                                                },
                                            },
                                            {
                                                path: "summary",
                                                name: "CompanyLocationSummary",
                                                component: () =>
                                                    import("@/views/location/LocationSummary.vue"),
                                                meta: { title: "Summary" },
                                            },
                                            {
                                                path: "flexibility",
                                                name: "CompanyLocationFlexibility",
                                                component: () =>
                                                    import(
                                                        "@/views/location-groups/LocationGroupHeaderView.vue"
                                                    ),
                                                meta: { title: "Flexibility" },
                                            },
                                            {
                                                path: "device-groups/:deviceGroupId",
                                                component: () =>
                                                    import("@/views/location/group/Group.vue"),
                                                meta: { type: "device-group" },
                                                children: [
                                                    {
                                                        path: "",
                                                        name: "CompanyDeviceGroup",
                                                        component: () =>
                                                            import(
                                                                "@/views/location/group/GroupOverview.vue"
                                                            ),
                                                        meta: {
                                                            title: "Group overview",
                                                            type: "device-group",
                                                        },
                                                    },
                                                    {
                                                        path: "devices/:did",
                                                        name: "CompanyDevice",
                                                        component: () =>
                                                            import(
                                                                "@/views/location/device/Device.vue"
                                                            ),
                                                        meta: { title: "Device", type: "device" },
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
]
